import { Component, inject, Input } from '@angular/core';
import { IonButtons, IonHeader, IonContent, IonToolbar, IonTitle, IonButton, ModalController, IonIcon, ToastController } from "@ionic/angular/standalone";
import { KendoGridParentComponent } from '../kendo-grid-parent/kendo-grid-parent.component';
import { ClipboardService } from '../../services/clipboard.service';

@Component({
  selector: 'lib-kendo-grid-modal',
  imports: [IonIcon, IonContent, IonHeader, IonButtons, KendoGridParentComponent, IonToolbar, IonTitle, IonButton],
  templateUrl: './kendo-grid-modal.component.html',
  styleUrl: './kendo-grid-modal.component.css'
})
export class KendoGridModalComponent {
 private modalCtrl = inject(ModalController);
 private clipboardService = inject(ClipboardService);
 private toastCtrl = inject(ToastController);
  @Input() gridConfig: { field: string; title: string; hidden?: boolean; display?: any; filterable?: boolean; filter?: string }[] = [];

  @Input() data: any[] = [];
  @Input() title?: string;

  // Helps Kendo Grid size nicely inside the modal
  @Input() gridHeight: number | string = 'calc(100vh - 56px)';

  onRowSelected(evt: any) {
    // Pass selected row back to the opener (optional)
    this.modalCtrl.dismiss({ selection: evt }, 'select');
  }

  close() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  buildGridCopyText(): string {
    const visibleColumns = (this.gridConfig ?? []).filter((column) => !column?.hidden);
    const header = this.title?.trim() || 'Grid Data';
    const lines = [header, `Rows: ${this.data?.length ?? 0}`];

    if (!visibleColumns.length || !(this.data?.length ?? 0)) {
      lines.push('', 'No rows to copy.');
      return lines.join('\n');
    }

    lines.push('');
    for (const [index, row] of this.data.entries()) {
      lines.push(`Row ${index + 1}`);
      for (const column of visibleColumns) {
        lines.push(`${column.title}: ${this.formatValue(this.resolvePath(row, column.field))}`);
      }
      if (index < this.data.length - 1) {
        lines.push('');
      }
    }

    return lines.join('\n');
  }

  async copyGridToClipboard(): Promise<void> {
    const copied = await this.clipboardService.copyText(this.buildGridCopyText());
    const toast = await this.toastCtrl.create({
      message: copied ? 'Grid data copied to clipboard.' : 'Unable to copy grid data.',
      duration: 1800,
      position: 'bottom',
      color: copied ? 'success' : 'danger'
    });
    await toast.present();
  }

  private resolvePath(row: any, path: string): any {
    if (!row || !path) return undefined;
    return path.split('.').reduce((value, key) => (value == null ? undefined : value[key]), row);
  }

  private formatValue(value: unknown): string {
    if (value == null || value === '') return '—';
    return String(value);
  }
}
